module.exports = __webpack_public_path__ + "img/text-blocks.167b5405.svg";